import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { finalize } from "rxjs/operators";
import { NotificationService } from "../notification.service";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";
@Component({
  selector: "app-send-push-notification",
  templateUrl: "./send-push-notification.component.html",
  styleUrls: ["./send-push-notification.component.sass"],
})
export class SendPushNotificationComponent implements OnInit {
  notificationForm!: FormGroup;
  imagePreview: string = "";
  uploadingImage = false;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private notificationService: NotificationService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
  ) {}
  @ViewChild("fileInput")
  fileInput!: ElementRef<HTMLInputElement>;
  ngOnInit(): void {
    this.buildForm();
  }
  private resetForm(): void {
    this.notificationForm.reset({
      audience: "",
      title: "",
      message: "",
      imageUrl: "",
    });

    this.imagePreview = "";

    if (this.fileInput) {
      this.fileInput.nativeElement.value = "";
    }
  }
  buildForm(): void {
    this.notificationForm = this.fb.group({
      audience: ["", Validators.required],

      title: ["", [Validators.required, Validators.maxLength(100)]],

      message: ["", [Validators.required, Validators.maxLength(500)]],

      imageUrl: ["", Validators.pattern(/^(https?:\/\/.*)?$/)],
    });
  }

  submit(): void {
    if (this.notificationForm.invalid) {
      this.notificationForm.markAllAsTouched();

      return;
    }

    this.spinner.show();

    this.notificationService
      .sendNotification(this.notificationForm.value)
      .pipe(finalize(() => this.spinner.hide()))
      .subscribe({
        next: (response: any) => {
          if (response.statusCode === 200) {
            this.toastr.success(response.message);

            this.resetForm();
          } else {
            this.toastr.error(response.message);
          }
        },

        error: () => {
          this.toastr.error("Unable to send notification.");
        },
      });
  }

  onImageSelected(event: any): void {
    const file = event.target.files[0];

    if (!file) {
      return;
    }

    // Validate type
    const allowedTypes = ["image/jpeg", "image/png", "image/webp"];

    if (!allowedTypes.includes(file.type)) {
      this.toastr.error("Only JPG, PNG and WEBP images are allowed.");

      return;
    }

    // Validate size (2 MB)

    if (file.size > 2 * 1024 * 1024) {
      this.toastr.error("Image size should not exceed 2 MB.");

      return;
    }

    this.uploadingImage = true;

    this.notificationService
      .addImage(file)
      .pipe(finalize(() => (this.uploadingImage = false)))
      .subscribe({
        next: (response: any) => {
          if (response.statusCode !== 200) {
            this.toastr.error("Image upload failed.");
            return;
          }

          const imageUrl = response.photoUrl;

          this.notificationForm.patchValue({
            imageUrl: imageUrl,
          });

          this.imagePreview = imageUrl;

          console.log(this.notificationForm.value);

          this.toastr.success("Image uploaded successfully.");
        },

        error: () => {
          this.toastr.error("Image upload failed.");
        },
      });
  }

  goToNotificationHistory(): void {
    this.router.navigate(["/dashboard/view-notification-history"]);
  }
}
